document.addEventListener("DOMContentLoaded", () => {
  // =============================================
  // 1. STATE MANAGEMENT
  // =============================================
  const PCLP_ROOT = document.getElementById("license-plate-fields");
  const state = {
    editedImage: null,
    quantity: "1 plate",
    embossing: "no",
    price: 11.99,
    color: "Gloss White",
    image: null,
    imageUrl: null,
    imageTransform: null,
    textOption: "no",
    font: "Anton",
    fontColor: "Gloss Black",
    middleText: "",
    topText: "",
    bottomText: "",
  };

  // =============================================
  // 2. PRICE VARIANTS
  // =============================================
  const PRICE_VARIANTS = {
    quantity: [
      { value: "1 plate", price: 0.0 },
      { value: "2 plates", price: 7.96 },
      { value: "3 plates", price: 14.96 },
      { value: "5 plates", price: 27.96 },
      { value: "10 plates", price: 59.96 },
      { value: "25 plates", price: 154.96 },
      { value: "50 plates", price: 299.96 },
      { value: "100 plates", price: 579.96 },
      { value: "500 plates", price: 2689.96 },
      { value: "1000 plates", price: 5189.96 },
    ],
    embossing: [
      { value: "no", price: 0.0 },
      { value: "yes", price: 15.0 },
    ],
  };

  const BASE_PRICE = 11.99;

  const COLOR_MAPPINGS = {
    "Gloss Black": "#000000",
    "Gloss White": "#FFFFFF",
    "Ice Blue": "#21B3DA",
    "Sky Blue": "#0498DE",
    "Azure Blue": "#0797DE",
    "Cobalt Blue": "#1A2A99",
    "Dark Blue": "#242D72",
    "Steel Blue": "#01084E",
    "Brimestone Yellow": "#FDF809",
    Yellow: "#FEDC01",
    "Signal Yellow": "#FFB600",
    "Golden Yellow": "#FFB401",
    "Pastel Orange": "#FF7111",
    Orange: "#FE7306",
    "Orange Red": "#F63700",
    Red: "#C70304",
    "Dark Red": "#960B04",
    Burgundy: "#5A121D",
    "Light Gray": "#E3DFE0",
    "Dark Gray": "#818181",
    Mint: "#22D095",
    Turquoise: "#02979B",
    "Lime Tree Green": "#52B12F",
    "Yellow Green": "#4A9E2C",
    Green: "#049049",
    "Forest Green": "#04370C",
    "Dark Green": "#012906",
    Lilac: "#DC89A5",
    Lavender: "#904E8B",
    Violet: "#721A44",
    Purple: "#711953",
    "Purple Red": "#8C112E",
    "Soft Pink": "#E66B87",
    "Bright Pink": "#F62B56",
    "Silver Gray Metallic": "#A4A7AC",
    "Gold metallic": "#C0B452",
    "Copper Metallic": "#822803",
    Cream: "#FBDC81",
    Beige: "#D8BD78",
    "Light Brown": "#C16B38",
    "Nut Brown": "#A93F18",
    Brown: "#350C06",
  };

  // =============================================
  // 3. HELPER FUNCTIONS
  // =============================================
  function show(el) {
    if (el) el.style.display = "";
  }

  function hide(el) {
    if (el) el.style.display = "none";
  }

  function animatePriceChange(targetElement, start, end, duration = 500) {
    let startTime = null;
    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const currentValue = start + (end - start) * progress;
      targetElement.textContent = currentValue.toFixed(2);

      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function priceOf(groupKey, chosenValue) {
    if (!chosenValue) return 0;
    const list = PRICE_VARIANTS[groupKey] || [];
    const found = list.find((item) => item.value === chosenValue);
    return found ? found.price : 0;
  }

  function debounce(func, delay) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  }

  function dataURLtoFile(dataurl, filename) {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  function disableBodyScroll() {
    const scrollY = window.scrollY;
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.dataset.scrollY = scrollY; // save position
  }

  function enableBodyScroll() {
    const scrollY = document.body.dataset.scrollY || 0;
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    window.scrollTo(0, parseInt(scrollY, 10));
    document.body.removeAttribute("data-scrollY");
  }

  function updateBuyBar(total) {
    const FREE_SHIP_THRESHOLD = 25;

    const qtyActive = (PCLP_ROOT || document).querySelector(
      "#quantity-variant .sticker-variant.active",
    );
    const plates = qtyActive?.dataset?.plates || "1";

    const labelEl = document.getElementById("pcs-total-label");
    const unitEl = document.getElementById("pcs-unit-price");
    if (labelEl) {
      labelEl.textContent = `TOTAL · ${plates} ${Number(plates) === 1 ? "PLATE" : "PLATES"}`;
    }
    const platesNum = Math.max(1, parseInt(plates, 10) || 1);
    if (unitEl) unitEl.textContent = `$${(total / platesNum).toFixed(2)}/ea`;

    const shipWrap = document.getElementById("pclp-shipping");
    const fillEl = document.getElementById("pclp-shipping-fill");
    const textEl = document.getElementById("pclp-shipping-text");
    if (!shipWrap || !fillEl) return;

    const toFree = FREE_SHIP_THRESHOLD - total;
    if (toFree <= 0) {
      shipWrap.classList.add("is-free");
      if (textEl)
        textEl.innerHTML = "You unlocked <strong>free shipping</strong>";
      fillEl.style.width = "100%";
    } else {
      shipWrap.classList.remove("is-free");
      if (textEl) {
        textEl.innerHTML = `Add <strong id="pclp-shipping-amount">$${toFree.toFixed(
          2,
        )}</strong> more for <strong>free shipping</strong>`;
      }
      const pct = Math.min(
        100,
        Math.round(
          ((FREE_SHIP_THRESHOLD - toFree) / FREE_SHIP_THRESHOLD) * 100,
        ),
      );
      fillEl.style.width = `${pct}%`;
    }
  }

  // =============================================
  // 4. IMAGE UPLOAD HANDLING
  // =============================================
  function setupImageUpload() {
    const artbox = document.getElementById("upload-artbox-image");
    const previewBox = document.getElementById("preview-box-image");
    const previewImg = document.getElementById("preview-image-image");
    const deleteBtn = document.getElementById("delete-image");
    const fileInput = document.getElementById("upload-file-image");
    const chooseBtn = document.getElementById("choose-file-btn-image");
    const errorMsg = document.getElementById("upload-file-error-image");
    if (
      !artbox ||
      !previewBox ||
      !previewImg ||
      !deleteBtn ||
      !fileInput ||
      !chooseBtn ||
      !errorMsg
    )
      return;
    chooseBtn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (chooseBtn.dataset.opening === "true") return;

      chooseBtn.dataset.opening = "true";
      fileInput.click();

      setTimeout(() => {
        chooseBtn.dataset.opening = "false";
      }, 500);
    });
    fileInput.addEventListener("click", () => {
      fileInput.value = "";
    });
    fileInput.addEventListener("change", (e) => {
      const file = e.target.files[0];
      if (!file) return;
      const allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/webp",
        "image/svg+xml",
      ];
      if (!allowedTypes.includes(file.type)) {
        errorMsg.textContent =
          "Please upload .jpg, .jpeg, .png, .svg, or .webp";
        errorMsg.classList.add("active");
        fileInput.value = "";
        return;
      }
      const reader = new FileReader();
      reader.onload = (ev) => {
        previewImg.src = ev.target.result;
        artbox.style.display = "none";
        previewBox.style.display = "block";
        errorMsg.classList.remove("active");
        state.image = file;
        state.imageUrl = ev.target.result;
        if (designer) designer.handleImageUpload({ target: { files: [file] } });
      };
      reader.readAsDataURL(file);
    });
    deleteBtn.addEventListener("click", () => {
      fileInput.value = "";
      artbox.style.display = "block";
      previewBox.style.display = "none";
      previewImg.src = "";
      errorMsg.classList.remove("active");
      state.image = null;
      state.imageUrl = null;
      state.imageTransform = null;
      state.editedImage = null;
      if (designer && designer.backgroundImage) {
        designer.canvas.remove(designer.backgroundImage);
        designer.backgroundImage = null;
        designer.canvas.renderAll();
        designer.updateFinishButtonState();
      }
    });
  }

  // =============================================
  // 5. DROPDOWN HANDLING
  // =============================================
  function initDropdownDefaults() {
    document.querySelectorAll(".select-dropdown").forEach((dd) => {
      const preSel = dd.querySelector("li.selected");
      const header = dd.querySelector(".selected-text");
      if (preSel && header) {
        header.textContent = preSel.textContent;
        const stateKey = dd.dataset.stateKey;
        if (stateKey && preSel.dataset.value) {
          state[stateKey] = preSel.dataset.value;
        }
      }
    });
  }

  function dropdownClickHandler(evt) {
    const dropdown = evt.target.closest(".select-dropdown");
    if (!dropdown) {
      document
        .querySelectorAll(".dropdown-options")
        .forEach((list) => hide(list));
      return;
    }
    const list = dropdown.querySelector(".dropdown-options");
    const header = dropdown.querySelector(".selected-text");
    const stateKey = dropdown.dataset.stateKey;
    const optionEl = evt.target.closest("li[data-value]");
    document.querySelectorAll(".dropdown-options").forEach((other) => {
      if (other !== list) hide(other);
    });
    if (optionEl) {
      const value = optionEl.dataset.value;
      if (!value) return;
      list
        .querySelectorAll("li")
        .forEach((li) => li.classList.remove("selected"));
      optionEl.classList.add("selected");
      header.textContent = optionEl.textContent;
      if (header.parentElement.classList.contains("color-dropdown")) {
        header.style.setProperty("--swatch", COLOR_MAPPINGS[value]);
      }
      dropdown.classList.add("variant-picked");
      if (stateKey) {
        state[stateKey] = value;
        const targetElement = document.getElementById(`${stateKey}-select`);
        if (targetElement) {
          const customEvent = new Event("change");
          customEvent.target = { value: value };
          targetElement.dispatchEvent(customEvent);
        }
        if (designer) {
          switch (stateKey) {
            case "color":
              designer.updateBackgroundColor(value);
              break;
            case "font":
              designer.updateFont(value);
              break;
            case "font_color":
              designer.updateFontColor(value);
              break;
            case "quantity":
              designer.updateFinishButtonState(); // Ensure button state reflects quantity
              break;
          }
        }
        recalcPrice();
      }
      hide(list);
      return;
    }
    list.style.display = list.style.display === "block" ? "none" : "block";
  }

  // =============================================
  // 6. TEXT OPTION HANDLING
  // =============================================
  function setupTextOption() {
    const variant = document.getElementById("text-option-variant");
    if (!variant) return;
    variant.addEventListener("click", (event) => {
      const selected = event.target.closest(".sticker-variant");
      if (!selected || !variant.contains(selected)) return;
      const list = selected.closest(".sticker-variants__list");
      if (!list) return;
      list.querySelectorAll(".sticker-variant").forEach((el) => {
        el.classList.toggle("active", el === selected);
      });
      const value =
        selected.dataset.textOption ||
        selected.getAttribute("data-text-option") ||
        "no";
      state.textOption = value;
      const textVariants = [
        "font-variant",
        "text-color-variant",
        "middle-text-variant",
        "top-text-variant",
        "bottom-text-variant",
      ];
      textVariants.forEach((id) => {
        const el = document.getElementById(id);
        if (el) el.style.display = value === "yes" ? "" : "none";
      });
      if (value === "yes" && !state.middleText) {
        const errorBar = document.getElementById("middle-text-error-bar");
        if (errorBar) errorBar.style.display = "block";
      } else {
        const errorBar = document.getElementById("middle-text-error-bar");
        if (errorBar) errorBar.style.display = "none";
      }
      if (designer) {
        designer.updateText(state.middleText, state.topText, state.bottomText);
        designer.updateFinishButtonState();
      }
    });
  }

  // =============================================
  // 7. TEXT INPUT HANDLING
  // =============================================
  function handleTextInputs() {
    const textInputs = [
      {
        id: "middle-text-input",
        counterId: "middle-text-char-count",
        stateKey: "middleText",
        errorId: "middle-text-error-bar",
        max: 50,
      },
      {
        id: "top-text-input",
        counterId: "top-text-char-count",
        stateKey: "topText",
        max: 50,
      },
      {
        id: "bottom-text-input",
        counterId: "bottom-text-char-count",
        stateKey: "bottomText",
        max: 50,
      },
    ];
    textInputs.forEach(({ id, counterId, stateKey, errorId, max }) => {
      const input = document.getElementById(id);
      const counter = document.getElementById(counterId);
      const error = errorId ? document.getElementById(errorId) : null;
      const wrapper = input?.parentElement;
      if (!input || !counter || (errorId && !error) || !wrapper) return;
      const refresh = () => {
        if (input.value.length > max) {
          input.value = input.value.slice(0, max);
        }
        state[stateKey] = input.value;
        const remaining = max - input.value.length;
        counter.textContent = `${remaining} character(s) left`;
        if (
          stateKey === "middleText" &&
          !input.value.trim() &&
          state.textOption === "yes"
        ) {
          if (error) error.style.display = "block";
          wrapper.classList.remove("variant-picked");
        } else if (input.value.trim()) {
          if (error) error.style.display = "none";
          wrapper.classList.add("variant-picked");
        } else {
          wrapper.classList.remove("variant-picked");
        }
        if (designer) {
          designer.updateText(
            state.middleText,
            state.topText,
            state.bottomText,
          );
          designer.updateFinishButtonState();
        }
      };
      input.addEventListener("input", refresh);
      refresh();
    });
  }

  // =============================================
  // 8. QUANTITY SELECTION
  // =============================================
  function setupQuantitySelection() {
    const variant = document.getElementById("quantity-variant");
    if (!variant) return;
    variant.addEventListener("click", (event) => {
      const selected = event.target.closest(".sticker-variant");
      if (!selected || !variant.contains(selected)) return;
      event.preventDefault();

      variant.querySelectorAll(".sticker-variant").forEach((el) => {
        el.classList.toggle("active", el === selected);
      });

      state.quantity = selected.dataset.quantity || "1 plate";
      variant.classList.add("variant-picked");
      recalcPrice();
      if (designer) designer.updateFinishButtonState();
    });
  }

  // =============================================
  // 9. EMBOSSING GLOSS SELECTION
  // =============================================
  function setupEmbossingSelection() {
    const variant = document.getElementById("embossing-gloss-variant");
    if (!variant) return;
    const offEl = variant.querySelector(".sticker-variant.pcs-sr-only");
    const onEl = variant.querySelector(".pcs-addon-row[data-embossing='yes']");
    if (!offEl || !onEl) return;

    variant.addEventListener("click", (event) => {
      const row = event.target.closest(".pcs-addon-row");
      if (!row) return;
      event.preventDefault();

      const isOn = onEl.classList.contains("active");
      offEl.classList.toggle("active", isOn);
      onEl.classList.toggle("active", !isOn);
      state.embossing = isOn ? "no" : "yes";
      recalcPrice();
    });
  }

  // =============================================
  // 10. PRICE CALCULATION
  // =============================================
  function recalcPrice() {
    let total = BASE_PRICE;
    total += priceOf("quantity", state.quantity) || 0;
    total += priceOf("embossing", state.embossing) || 0;
    total = Math.round(total * 100) / 100;
    const priceEl = document.getElementById("pcs-final-price");
    if (priceEl) {
      const prevValue = parseFloat(priceEl.textContent) || 0;
      if (prevValue !== total) {
        animatePriceChange(priceEl, prevValue, total);
      }
    }
    state.price = total;
    updateBuyBar(total);
  }

  // =============================================
  // 11. DELETE PREVIEW
  // =============================================
  const deleteBannerImage = document.getElementById("delete-banner-image");
  deleteBannerImage.addEventListener("click", () => {
    const artbox = document.getElementById("upload-artbox");
    const previewBox = document.getElementById("preview-box");
    const mainVariants = document.getElementById("main-variants");
    const previewImage = document.getElementById("preview-image");
    const fileInput = document.getElementById("upload-file-image");
    if (designer && designer.backgroundImage) {
      designer.canvas.remove(designer.backgroundImage);
      designer.backgroundImage = null;
    }
    if (designer && designer.middleText) {
      designer.canvas.remove(designer.middleText);
      designer.middleText = null;
    }
    if (designer && designer.topText) {
      designer.canvas.remove(designer.topText);
      designer.topText = null;
    }
    if (designer && designer.bottomText) {
      designer.canvas.remove(designer.bottomText);
      designer.bottomText = null;
    }
    designer.canvas.renderAll();
    designer.updateFinishButtonState();
    if (artbox) artbox.style.display = "block";
    if (previewBox) previewBox.style.display = "none";
    if (mainVariants) mainVariants.style.display = "none";
    if (previewImage) previewImage.src = "";
    if (fileInput) fileInput.value = "";
    state.image = null;
    state.imageUrl = null;
    state.imageTransform = null;
    state.editedImage = null;
    state.middleText = "";
    state.topText = "";
    state.bottomText = "";
    const middleInput = document.getElementById("middle-text-input");
    const topInput = document.getElementById("top-text-input");
    const bottomInput = document.getElementById("bottom-text-input");
    if (middleInput) middleInput.value = "";
    if (topInput) topInput.value = "";
    if (bottomInput) bottomInput.value = "";
    const middleCounter = document.getElementById("middle-text-char-count");
    const topCounter = document.getElementById("top-text-char-count");
    const bottomCounter = document.getElementById("bottom-text-char-count");
    if (middleCounter) middleCounter.textContent = "50 character(s) left";
    if (topCounter) topCounter.textContent = "50 character(s) left";
    if (bottomCounter) bottomCounter.textContent = "50 character(s) left";
    const middleError = document.getElementById("middle-text-error-bar");
    if (middleError) middleError.style.display = "none";
    document
      .querySelectorAll(".pcs-variant")
      .forEach((el) => el.classList.remove("variant-picked"));
    recalcPrice();
  });

  // =============================================
  // 12. FORM VALIDATION
  // =============================================
  function validateForm() {
    let firstInvalid = null;
    function toggleError(id, show, message = "") {
      const bar = document.getElementById(id);
      if (!bar) return;
      if (message) bar.textContent = message;
      bar.style.display = show ? "block" : "none";
      const variantBox = bar.closest(".pcs-variant");
      if (variantBox) variantBox.classList.toggle("has-error", show);
      if (show && !firstInvalid) firstInvalid = variantBox || bar;
    }

    const designValid = !!state.editedImage;
    const uploadErrorEl = document.getElementById("upload-design-error");
    const artworkVariant = document.getElementById("artwork-variant");
    if (uploadErrorEl) {
      uploadErrorEl.textContent = designValid
        ? ""
        : "Please upload your design first.";
      uploadErrorEl.style.display = designValid ? "none" : "block";
    }
    if (artworkVariant) {
      artworkVariant.classList.toggle("has-error", !designValid);
      if (!designValid && !firstInvalid) firstInvalid = artworkVariant;
    }

    toggleError(
      "quantity-error-bar",
      !state.quantity,
      "Please select a quantity.",
    );
    if (state.textOption === "yes" && !state.middleText.trim()) {
      toggleError("middle-text-error-bar", true, "Please enter Middle Text.");
    }
    if (firstInvalid) {
      firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
      return false;
    }
    return true;
  }

  // =============================================
  // 13. RESET FORM
  // =============================================
  function resetCalculatorForm() {
    state.quantity = "1 plate";
    state.embossing = "no";
    state.color = "Gloss White";
    state.image = null;
    state.imageUrl = null;
    state.textOption = "no";
    state.font = "Anton";
    state.fontColor = "Gloss Black";
    state.middleText = "";
    state.topText = "";
    state.bottomText = "";
    state.editedImage = null;
    state.imageTransform = null;
    const quantityVariant = document.getElementById("quantity-variant");
    if (quantityVariant) {
      quantityVariant.querySelectorAll(".sticker-variant").forEach((el) => {
        el.classList.toggle("active", el.dataset.quantity === "1 plate");
      });
      quantityVariant.classList.remove("variant-picked");
    }
    const embossingVariant = document.getElementById("embossing-gloss-variant");
    if (embossingVariant) {
      const offEl = embossingVariant.querySelector(
        ".sticker-variant.pcs-sr-only[data-embossing='no']",
      );
      const onEl = embossingVariant.querySelector(
        ".pcs-addon-row[data-embossing='yes']",
      );
      if (offEl && onEl) {
        offEl.classList.add("active");
        onEl.classList.remove("active");
      }
    }
    const colorDropdown = document.getElementById("color-select");
    if (colorDropdown) {
      const list = colorDropdown.querySelector(".dropdown-options");
      const header = colorDropdown.querySelector(".selected-text");
      if (list && header) {
        list
          .querySelectorAll("li")
          .forEach((li) => li.classList.remove("selected"));
        const defaultOption = list.querySelector(
          "li[data-value='Gloss White']",
        );
        if (defaultOption) {
          defaultOption.classList.add("selected");
          header.textContent = defaultOption.textContent.trim();
          header.style.setProperty("--swatch", COLOR_MAPPINGS["Gloss White"]);
        }
        hide(list);
        colorDropdown.classList.remove("variant-picked");
      }
    }
    const textOptionVariant = document.getElementById("text-option-variant");
    if (textOptionVariant) {
      const list = textOptionVariant.querySelector(".sticker-variants__list");
      if (list) {
        list.querySelectorAll(".sticker-variant").forEach((el) => {
          el.classList.toggle("active", el.dataset.textOption === "no");
        });
      }
    }
    const textVariants = [
      "font-variant",
      "text-color-variant",
      "middle-text-variant",
      "top-text-variant",
      "bottom-text-variant",
    ];
    textVariants.forEach((id) => {
      const el = document.getElementById(id);
      if (el) el.style.display = "none";
    });
    const fontDropdown = document.getElementById("font-select");
    if (fontDropdown) {
      const list = fontDropdown.querySelector(".dropdown-options");
      const header = fontDropdown.querySelector(".selected-text");
      if (list && header) {
        list
          .querySelectorAll("li")
          .forEach((li) => li.classList.remove("selected"));
        const firstOption = list.querySelector("li[data-value]");
        if (firstOption) {
          firstOption.classList.add("selected");
          header.textContent = firstOption.textContent.trim();
          header.classList.forEach((cls) => {
            if (cls.startsWith("font-")) header.classList.remove(cls);
          });
          firstOption.classList.forEach((cls) => {
            if (cls.startsWith("font-")) header.classList.add(cls);
          });
        }
        hide(list);
        fontDropdown.classList.remove("variant-picked");
      }
    }
    const textColorDropdown = document.getElementById("text-color-select");
    if (textColorDropdown) {
      const list = textColorDropdown.querySelector(".dropdown-options");
      const header = textColorDropdown.querySelector(".selected-text");
      if (list && header) {
        list
          .querySelectorAll("li")
          .forEach((li) => li.classList.remove("selected"));
        const defaultOption = list.querySelector(
          "li[data-value='Gloss Black']",
        );
        if (defaultOption) {
          defaultOption.classList.add("selected");
          header.textContent = defaultOption.textContent.trim();
          header.style.setProperty("--swatch", COLOR_MAPPINGS["Gloss Black"]);
        }
        hide(list);
        textColorDropdown.classList.remove("variant-picked");
      }
    }
    const textInputs = [
      {
        id: "middle-text-input",
        counterId: "middle-text-char-count",
        errorId: "middle-text-error-bar",
      },
      { id: "top-text-input", counterId: "top-text-char-count" },
      { id: "bottom-text-input", counterId: "bottom-text-char-count" },
    ];
    textInputs.forEach(({ id, counterId, errorId }) => {
      const input = document.getElementById(id);
      const counter = document.getElementById(counterId);
      const error = errorId ? document.getElementById(errorId) : null;
      if (input) {
        input.value = "";
        if (counter) counter.textContent = "50 character(s) left";
        if (error) error.style.display = "none";
        const wrapper = input.parentElement;
        if (wrapper) wrapper.classList.remove("variant-picked");
      }
    });
    const artbox = document.getElementById("upload-artbox-image");
    const previewBox = document.getElementById("preview-box-image");
    const previewImage = document.getElementById("preview-image-image");
    const fileInput = document.getElementById("upload-file-image");
    if (artbox) artbox.style.display = "block";
    if (previewBox) previewBox.style.display = "none";
    if (previewImage) previewImage.src = "";
    if (fileInput) fileInput.value = "";
    document.querySelectorAll(".error-bar").forEach((el) => hide(el));
    const uploadDesignError = document.getElementById("upload-design-error");
    if (uploadDesignError) {
      uploadDesignError.textContent = "";
      uploadDesignError.style.display = "none";
    }
    document
      .querySelectorAll(".pcs-variant")
      .forEach((el) => el.classList.remove("has-error"));
    recalcPrice();
    if (designer) {
      designer.handleRemoveAll();
    }
  }

  // =============================================
  // 14. ADD TO CART
  // =============================================
  const PCS_CART_BTN_HTML = `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="20" r="1.5"/><circle cx="18" cy="20" r="1.5"/><path d="M2 3h3l2.4 12.4a2 2 0 0 0 2 1.6h8.2a2 2 0 0 0 2-1.6L23 6H6"/></svg> Add to cart`;

  const PCS_CART_LOADING_HTML = `<span class="pcs-cart-loading"><svg class="pcs-cart-loading__icon" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M21 12a9 9 0 1 1-6.22-8.56"/></svg>Adding to cart</span>`;

  function setupApippaAddToCart() {
    const addToCartBtn = document.getElementById("pclp-add-to-cart");
    if (!addToCartBtn) return;
    if (addToCartBtn.dataset.bound) return;
    addToCartBtn.dataset.bound = "true";

    addToCartBtn.addEventListener("click", async (e) => {
      e.preventDefault();
      if (!validateForm()) {
        console.log("Form invalid – fix the highlighted fields.");
        return;
      }

      addToCartBtn.classList.remove("shine");
      addToCartBtn.disabled = true;
      addToCartBtn.classList.add("loading");
      addToCartBtn.innerHTML = PCS_CART_LOADING_HTML;
      try {
        const requestData = {
          calculatorId: "40d3047800b54",
          productId: 7754307764272,
          properties: {
            "Background Color": state.color,
            "Middle Text": state.middleText || "",
            "Top Text": state.topText || "",
            "Bottom Text": state.bottomText || "",
            Font:
              state.textOption === "yes" &&
              (state.middleText || state.topText || state.bottomText).trim()
                ? state.font
                : "",
            "Font Color":
              state.textOption === "yes" &&
              (state.middleText || state.topText || state.bottomText).trim()
                ? state.fontColor
                : "",
            Quantity: state.quantity,
            "Add Embossing Gloss": state.embossing,
            "Edited Image": state.editedImage ? state.editedImage : "",
            "Upload Image": state.image ? state.image : "",
          },
        };
        console.log("Request Data: ", requestData);
        const variantRes = await fetch(
          "https://api.custompricecalculator.com/api/v1/variant",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(requestData),
          },
        );
        const variantId = await variantRes.json();
        const shopifyVariantId =
          typeof variantId === "string"
            ? variantId
            : variantId?.variantId || variantId?.id;
        if (!shopifyVariantId) throw new Error("Invalid variant ID");
        const formData = new FormData();
        formData.append("id", shopifyVariantId);
        formData.append("quantity", 1);
        Object.entries(requestData.properties).forEach(([key, value]) => {
          if (value instanceof File) {
            formData.append(`properties[${key}]`, value);
          } else {
            formData.append(`properties[${key}]`, value);
          }
        });
        const cartAddRes = await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
        });
        const cartAddJson = await cartAddRes.json();
        if (!cartAddRes.ok) throw new Error("Failed to add to cart");
        localStorage.setItem(
          `patched-cart-item-${cartAddJson.id}`,
          JSON.stringify({
            id: cartAddJson.id,
            title: cartAddJson.product_title,
            image: cartAddJson.image,
            price: cartAddJson.price,
          }),
        );
        const timestamp = new Date().getTime();
        await new Promise((resolve) => setTimeout(resolve, 200));
        const sectionHtml = await fetch(
          `/cart?section_id=mini-cart&t=${timestamp}`,
        ).then((res) => res.text());
        const fakeDiv = document.createElement("div");
        fakeDiv.innerHTML = sectionHtml;
        const miniCartHTML = fakeDiv.querySelector("cart-drawer")?.outerHTML;
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer && miniCartHTML) {
          cartDrawer.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
              detail: {
                cart: {
                  items: [cartAddJson],
                  item_count: 1,
                  total_price: cartAddJson.final_price,
                  original_total_price: cartAddJson.original_price,
                  total_discount: 0,
                  sections: { "mini-cart": miniCartHTML },
                },
                openMiniCart: true,
              },
            }),
          );
        }
        setTimeout(() => {
          const lineItems = cartDrawer.querySelectorAll("line-item");
          lineItems.forEach((lineItem) => {
            const desktopPriceContainer = lineItem.querySelector(
              ".line-item__price-list-container .price",
            );
            const mobilePriceContainer = lineItem.querySelector(
              ".product-item-meta__price-list-container .price-list.hidden-tablet-and-up .price",
            );
            if (!desktopPriceContainer && !mobilePriceContainer) return;
            const priceText = (
              desktopPriceContainer || mobilePriceContainer
            ).textContent.trim();
            const isFree = /Free|$0\.00/.test(priceText);
            let variantId;
            const productLink = lineItem.querySelector("a[href*='?variant=']");
            if (productLink?.href.includes("variant=")) {
              variantId = productLink.href.split("variant=")[1].split("&")[0];
            }
            if (!variantId) {
              const removeBtn = lineItem.querySelector(
                "a[href*='/cart/change?id=']",
              );
              const removeHref = removeBtn?.getAttribute("href") || "";
              const match = removeHref.match(/id=(\d+):/);
              variantId = match?.[1];
            }
            if (isFree && variantId == shopifyVariantId) {
              const matchingItem = {
                id: cartAddJson.id,
                price: cartAddJson.price,
              };
              if (matchingItem) {
                const correctPrice = (matchingItem.price / 100).toFixed(2);
                const imageWrapper = lineItem.querySelector(
                  ".line-item__image-wrapper",
                );
                const productThumbnail = imageWrapper.querySelector(
                  "img.line-item__image",
                );
                const productTitle = lineItem.querySelector(
                  ".product-item-meta .product-item-meta__title",
                );
                if (!productThumbnail) {
                  const imgSrc = document.querySelector(
                    ".product__thumbnail-item .product__thumbnail img",
                  )?.src;
                  if (imgSrc) {
                    imageWrapper.innerHTML += `<img src="${imgSrc}" alt="" srcset="${imgSrc}" width="1024" height="1024" loading="lazy" sizes="(max-width: 740px) 80px, 92px" class="line-item__image">`;
                  }
                }
                if (productTitle.textContent.trim() === "") {
                  productTitle.textContent = document.querySelector(
                    ".product__info .product-meta__title",
                  ).textContent;
                }
                const updatedPriceHTML = `
                    <span class="visually-hidden">Sale price</span>
                    $${correctPrice}
                  `;
                if (desktopPriceContainer) {
                  desktopPriceContainer.innerHTML = updatedPriceHTML;
                }
                if (mobilePriceContainer) {
                  mobilePriceContainer.innerHTML = updatedPriceHTML;
                }
              }
            }
          });
        }, 300);

        setTimeout(async () => {
          const cartJson = await fetch("/cart.js").then((res) => res.json());
          const cartCountEl = document.querySelector("cart-count");
          if (cartCountEl) {
            cartCountEl.textContent = cartJson.item_count;
          }
        }, 300);

        setTimeout(() => {
          const drawerContent = document.querySelector(
            "#shopify-section-mini-cart .drawer__content",
          );
          if (!drawerContent) return;
          const confetti = document.createElement("dotlottie-player");
          confetti.className = "mini-cart-lottie";
          confetti.src =
            "//cdn.shopify.com/s/files/1/0582/5400/0176/files/confetti.json?v=1748024242";
          confetti.setAttribute("background", "transparent");
          confetti.setAttribute("speed", "1");
          confetti.setAttribute("style", "width: 300px; height: 300px");
          confetti.setAttribute("autoplay", "");
          drawerContent.prepend(confetti);
          setTimeout(() => {
            confetti.remove();
          }, 3000);
        }, 1000);
      } catch (err) {
        console.error("Apippa Add to Cart Error:", err);
        alert("There was a problem adding your item to the cart.");
      } finally {
        addToCartBtn.disabled = false;
        addToCartBtn.classList.remove("loading");
        addToCartBtn.innerHTML = PCS_CART_BTN_HTML;
        resetCalculatorForm();
        recalcPrice();
      }
    });
  }

  function playCartButtonShine() {
    const btn = document.getElementById("pclp-add-to-cart");
    if (!btn || btn.classList.contains("loading")) return;
    btn.classList.remove("shine");
    void btn.offsetWidth;
    btn.classList.add("shine");
  }

  function setupCartButtonShine() {
    const btn = document.getElementById("pclp-add-to-cart");
    if (!btn || btn.dataset.shineBound) return;
    btn.dataset.shineBound = "true";

    setTimeout(playCartButtonShine, 1500);
    setInterval(playCartButtonShine, 5000);
  }

  // =============================================
  // 15. LICENSE PLATE DESIGNER CLASS
  // =============================================
  class LicensePlateDesigner {
    constructor() {
      this.canvas = null;
      this.clipPath = null;
      this.backgroundRect = null;
      this.middleText = null;
      this.topText = null;
      this.bottomText = null;
      this.backgroundImage = null;
      this.guidelineObjects = [];
      this.snappingEnabled = false;
      this._ro = null;
      this.holeObjects = [];
      this.icons = {
        resizeLeft:
          "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/white-resize-left.webp",
        resizeRight:
          "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/white-resize-right.webp",
        resizeHorizontal:
          "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/white-resize-horizontal.webp",
        stackUp:
          "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/stackup.webp",
        stackDown:
          "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/stackdown.webp",
        rotate:
          "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/rotate.webp",
      };
      this.init();
    }

    init() {
      const canvasContainer = document.getElementById("canvasContainer");
      if (!canvasContainer) {
        console.error("Canvas container not found");
        return;
      }
      canvasContainer.innerHTML = '<canvas id="stickerCanvas"></canvas>';
      this.canvas = new fabric.Canvas("stickerCanvas", {
        width: canvasContainer.offsetWidth,
        height: canvasContainer.offsetHeight,
        preserveObjectStacking: true,
        controlsAboveOverlay: true,
        selection: true,
      });
      this.setupCanvas();
      this.setupEventListeners();
      this.setupCustomControls();
      this.observeContainerResize(canvasContainer);
      this.updateCanvasSize();
      this.drawClipPath();
      this.updateFinishButtonState();
      setupImageUpload();
    }

    observeContainerResize(container) {
      const ro = new ResizeObserver(debounce(() => this.handleResize(), 120));
      ro.observe(container);
      this._ro = ro;
    }

    setupCanvas() {
      if (!this.canvas) return;
      this.canvas.preserveObjectStacking = true;
      this.canvas.controlsAboveOverlay = true;
      this.canvas.selection = true;
    }

    setupEventListeners() {
      window.addEventListener(
        "resize",
        debounce(() => this.handleResize(), 300),
      );

      document.addEventListener("keydown", (e) => {
        const obj = this.canvas?.getActiveObject();
        if (!obj || obj !== this.middleText) return;
        const mod = e.ctrlKey || e.metaKey;
        if (mod && e.key === "]") {
          const cur = this.canvas.getObjects().indexOf(obj);
          const maxIdx = this._topCeilingIndex();
          if (cur < maxIdx) this.canvas.bringForward(obj);
          this._guardZ(obj);
          e.preventDefault();
        } else if (mod && e.key === "[") {
          const cur = this.canvas.getObjects().indexOf(obj);
          const minIdx = this._bgTopIndex() + 1;
          if (cur > minIdx) this.canvas.sendBackwards(obj);
          this._guardZ(obj);
          e.preventDefault();
        }
      });

      const getStartedBtn = document.getElementById("get-started-btn");
      if (getStartedBtn) {
        getStartedBtn.addEventListener("click", () => {
          const designerTool = document.getElementById("designerTool");

          if (designerTool) {
            designerTool.classList.add("active");
            disableBodyScroll();
          }

          this.restoreCanvasAfterPreview();
        });
      }

      const closeBtn = document.getElementById("designer-tool-close-btn");
      if (closeBtn) {
        closeBtn.addEventListener("click", () => {
          const popup = document.getElementById("close-tool-popup");
          if (popup) popup.classList.add("active");
        });
      }

      const cancelClose = document.getElementById("cancel-close-tool");
      if (cancelClose) {
        cancelClose.addEventListener("click", () => {
          const popup = document.getElementById("close-tool-popup");
          if (popup) popup.classList.remove("active");
        });
      }

      const confirmClose = document.getElementById("confirm-close-tool");
      if (confirmClose) {
        confirmClose.addEventListener("click", () => {
          const popup = document.getElementById("close-tool-popup");
          const designerTool = document.getElementById("designerTool");
          if (popup) popup.classList.remove("active");
          if (designerTool) {
            designerTool.classList.remove("active");
            enableBodyScroll();
          }
        });
      }

      const toggleGuides = document.getElementById("toggleGuides");
      if (toggleGuides) {
        toggleGuides.addEventListener("change", (e) => {
          this.toggleGuidelines(e.target.checked);
        });
      }

      const toggleSnap = document.getElementById("toggleSnap");
      if (toggleSnap) {
        toggleSnap.addEventListener("change", (e) => {
          this.snappingEnabled = e.target.checked;
        });
      }

      const btnEditImage = document.getElementById("btnEditImage");
      if (btnEditImage) {
        btnEditImage.addEventListener("click", () => {
          const designerTool = document.getElementById("designerTool");

          if (designerTool) {
            designerTool.classList.add("active");
            disableBodyScroll();
          }

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              if (!this.canvas) return;

              this.canvas.calcOffset();
              this.updateCanvasSize();

              // Ab restore karo, jab container visible ho chuka hai
              this.restoreCanvasAfterPreview();
            });
          });
        });
      }

      document.querySelectorAll(".align-btn[data-align]").forEach((btn) =>
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.alignObjects(e.currentTarget.dataset.align);
        }),
      );

      document
        .querySelectorAll(".text-align-btn[data-text-align]")
        .forEach((btn) =>
          btn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();

            const align = e.currentTarget.dataset.textAlign;
            const obj = this.canvas?.getActiveObject();

            if (obj && obj.type === "text") {
              obj.set("textAlign", align);
              obj.initDimensions?.();
              obj.setCoords();
              this.canvas.requestRenderAll();
            } else if (this.middleText) {
              this.middleText.set("textAlign", align);
              this.middleText.initDimensions?.();
              this.middleText.setCoords();
              this.canvas.requestRenderAll();
            }
          }),
        );

      const finishEditing = document.getElementById("finishEditing");
      if (finishEditing) {
        finishEditing.addEventListener("click", () => this.finishEditing());
      }

      const colorSelect = document.getElementById("color-select");
      if (colorSelect) {
        colorSelect.addEventListener("change", (e) => {
          if (e.target.value) this.updateBackgroundColor(e.target.value);
        });
      }

      const fontSelect = document.getElementById("font-select");
      if (fontSelect) {
        fontSelect.addEventListener("change", (e) => {
          if (e.target.value) this.updateFont(e.target.value);
        });
      }

      const textColorSelect = document.getElementById("text-color-select");
      if (textColorSelect) {
        textColorSelect.addEventListener("change", (e) => {
          if (e.target.value) this.updateFontColor(e.target.value);
        });
      }

      this.canvas.on("selection:created", (e) => {
        if (
          e.selected &&
          e.selected.length === 1 &&
          e.selected[0] === this.middleText
        ) {
          const tools = document.getElementById("text-align-tools");
          if (tools) tools.style.display = "flex";
        }
      });

      this.canvas.on("selection:updated", (e) => {
        const tools = document.getElementById("text-align-tools");
        const onlyOne = e.selected && e.selected.length === 1;
        const isMiddleText = onlyOne && e.selected[0] === this.middleText;
        if (tools) tools.style.display = isMiddleText ? "flex" : "none";
      });

      this.canvas.on("selection:cleared", () => {
        const textAlignTools = document.getElementById("text-align-tools");
        if (textAlignTools) textAlignTools.style.display = "none";
      });

      this.canvas.on("object:moving", (e) => {
        if (!this.snappingEnabled || !this.clipPath || !e.target) return;

        const obj = e.target;

        if (
          obj === this.backgroundRect ||
          this.guidelineObjects.includes(obj) ||
          this.holeObjects.includes(obj)
        ) {
          return;
        }

        this.snapObjectSmooth(obj);
      });

      this.canvas.on("object:modified", (e) => {
        if (!e.target) return;
        e.target.__snapX = null;
        e.target.__snapY = null;
      });

      this.canvas.on("mouse:up", () => {
        const obj = this.canvas?.getActiveObject();
        if (!obj) return;
        obj.__snapX = null;
        obj.__snapY = null;
      });
    }

    restoreCanvasAfterPreview() {
      if (!this.canvas) return;

      // Agar clipPath kisi hidden resize ki wajah se null ho gaya ho,
      // to visible hone ke baad dobara plate draw karo.
      if (!this.clipPath) {
        this.drawClipPath();
      }

      if (this.backgroundRect) {
        this.backgroundRect.set({
          fill: COLOR_MAPPINGS[state.color] || "#FFFFFF",
        });
      }

      if (this.backgroundImage) {
        this.backgroundImage.set({
          selectable: true,
          evented: true,
          hasControls: true,
          hasBorders: true,
        });
        this.backgroundImage.setCoords();
        this.canvas.setActiveObject(this.backgroundImage);
      }

      if (this.middleText) this.middleText.setCoords();
      if (this.topText) this.topText.setCoords();
      if (this.bottomText) this.bottomText.setCoords();

      this._drawGuides?.();
      this._ensureHolesOnTop?.();

      this.canvas.calcOffset();
      this.canvas.requestRenderAll();
      this.updateFinishButtonState();
    }

    setupCustomControls() {
      const preload = (src) =>
        new Promise((resolve, reject) => {
          const img = new Image();
          img.crossOrigin = "anonymous";
          img.onload = () => resolve(img);
          img.onerror = reject;
          img.src = src;
        });

      Promise.all([
        preload(this.icons.resizeLeft),
        preload(this.icons.resizeRight),
        preload(this.icons.resizeHorizontal),
        preload(this.icons.stackUp),
        preload(this.icons.stackDown),
        preload(this.icons.rotate),
      ])
        .then(
          ([
            resizeLeftImg,
            resizeRightImg,
            resizeHImg,
            stackUpImg,
            stackDownImg,
            rotateImg,
          ]) => {
            this.applyCustomCornerIcons(
              resizeLeftImg,
              resizeRightImg,
              resizeHImg,
              stackUpImg,
              stackDownImg,
              rotateImg,
            );
          },
        )
        .catch((e) => console.warn("Icon preload failed:", e));

      fabric.Object.prototype.transparentCorners = false;
      fabric.Object.prototype.cornerColor = "black";
      fabric.Object.prototype.borderColor = "black";
      fabric.Object.prototype.cornerStyle = "circle";
      fabric.Object.prototype.cornerStrokeColor = "black";
      fabric.Object.prototype.borderScaleFactor = 1;
    }

    applyCustomCornerIcons(
      iconLeft,
      iconRight,
      iconHorizontal,
      iconStackUp,
      iconStackDown,
      iconRotate,
    ) {
      const renderIcon = (icon) =>
        function (ctx, left, top, _style, fabricObject) {
          const size = this.cornerSize || 24;
          ctx.save();
          ctx.translate(left, top);
          ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle || 0));
          ctx.drawImage(icon, -size / 2, -size / 2, size, size);
          ctx.restore();
        };

      const setCtrl = (key, opts) => {
        const ctrl = fabric.Object.prototype.controls[key];
        if (ctrl) Object.assign(ctrl, opts);
      };

      const cornerSize = 25;
      setCtrl("tl", { render: renderIcon(iconLeft), cornerSize });
      setCtrl("tr", { render: renderIcon(iconRight), cornerSize });
      setCtrl("bl", { render: renderIcon(iconRight), cornerSize });
      setCtrl("br", { render: renderIcon(iconLeft), cornerSize });

      const midSize = 25;
      setCtrl("ml", {
        render: renderIcon(iconHorizontal),
        cornerSize: midSize,
      });
      setCtrl("mr", {
        render: renderIcon(iconHorizontal),
        cornerSize: midSize,
      });

      fabric.Object.prototype.setControlsVisibility({
        mt: false,
        mb: false,
        ml: false,
        mr: false,
      });

      const self = this;

      const ICON_SIZE = 25;
      const OFFSET_X = 25;
      const OFFSET_Y = 12;
      const GAP_Y = 6;

      const makeTopRightControl = (name, order, iconImg, onClick) => {
        fabric.Object.prototype.controls[name] = new fabric.Control({
          x: 0.5,
          y: -0.5,
          offsetX: OFFSET_X,
          offsetY: OFFSET_Y + order * (ICON_SIZE + GAP_Y),
          cornerSize: ICON_SIZE,
          cursorStyle: "pointer",
          render: renderIcon(iconImg),
          mouseUpHandler: (_evt, transform) => {
            const obj = transform.target;
            if (!obj || !obj.canvas) return;
            onClick(obj);
            self._guardZ(obj);
            obj.canvas.setActiveObject(obj);
            obj.canvas.requestRenderAll();
          },
        });
      };

      makeTopRightControl("bringFwd", 0, iconStackUp, (obj) => {
        const cur = obj.canvas.getObjects().indexOf(obj);
        const maxIdx = self._topCeilingIndex();
        if (cur < maxIdx) obj.canvas.bringForward(obj);
      });

      makeTopRightControl("sendBack", 1, iconStackDown, (obj) => {
        const cur = obj.canvas.getObjects().indexOf(obj);
        const minIdx = self._bgTopIndex() + 1;
        if (cur > minIdx) obj.canvas.sendBackwards(obj);
      });

      const ROTATE_SIZE = 26;
      const ROTATE_OFFSETY = -32;

      fabric.Object.prototype.controls.mtr = new fabric.Control({
        x: 0,
        y: -0.5,
        offsetY: ROTATE_OFFSETY,
        cornerSize: ROTATE_SIZE,
        cursorStyleHandler: fabric.controlsUtils.rotationStyleHandler,
        actionHandler: fabric.controlsUtils.rotationWithSnapping,
        actionName: "rotate",
        render: renderIcon(iconRotate),
        withConnection: true,
        connectionStyle: { stroke: "#000", strokeWidth: 1 },
      });
    }

    _topCeilingIndex() {
      if (!this.canvas) return -1;
      return this.canvas.getObjects().length - 1;
    }

    _bgTopIndex() {
      if (!this.canvas) return -1;
      const objs = this.canvas.getObjects();
      return this.backgroundRect ? objs.indexOf(this.backgroundRect) : -1;
    }

    _ensureHolesOnTop() {
      if (!this.canvas) return;
      this.holeObjects.forEach((h) => this.canvas.bringToFront(h));
    }

    _guardZ(obj) {
      if (!this.canvas || !obj) return;
      const objs = this.canvas.getObjects();
      const bgTop = this._bgTopIndex();
      const topCap = this._topCeilingIndex();
      let cur = objs.indexOf(obj);
      if (bgTop >= 0 && cur <= bgTop) this.canvas.moveTo(obj, bgTop + 1);
      cur = objs.indexOf(obj);
      if (topCap >= 0 && cur > topCap) this.canvas.moveTo(obj, topCap);
      this.canvas.requestRenderAll();
    }

    handleResize() {
      if (!this.canvas) return;

      const designerTool = document.getElementById("designerTool");
      const container = document.getElementById("canvasContainer");

      if (
        !designerTool?.classList.contains("active") ||
        !container ||
        container.clientWidth === 0 ||
        container.clientHeight === 0
      ) {
        return;
      }

      this.updateCanvasSize();
      this.drawClipPath();
      this.canvas.requestRenderAll();
    }

    updateCanvasSize() {
      const container = document.getElementById("canvasContainer");
      if (!container || !this.canvas) return;

      const width = Math.max(1, container.clientWidth || 1);
      const small = window.matchMedia("(max-width: 640px)").matches;
      const ratio = 12 / 6; // width / height for 12x6 inches
      let height;

      if (small) {
        height = Math.max(120, Math.round(width / ratio));
        const nearSquare = ratio >= 0.9 && ratio <= 1.1;
        const midSquare = ratio > 0.75 && ratio < 1.33;
        const shrink = nearSquare ? 0.82 : midSquare ? 0.9 : 1;
        height = Math.round(height * shrink);
        const maxVH = Math.floor(window.innerHeight * 0.6);
        height = Math.min(height, maxVH);
      } else {
        height = Math.max(
          1,
          container.clientHeight || Math.round(width / ratio),
        );
      }

      this.canvas.setDimensions({ width, height });
      this.canvas.calcOffset();
      this.canvas.renderAll();
    }

    getPlateSize() {
      return { width: 12, height: 6 }; // in inches, updated to 12x6
    }

    mobileFillForRatio(ratio) {
      if (ratio >= 0.9 && ratio <= 1.1) return 0.88;
      if (ratio >= 1.6 || ratio <= 0.625) return 0.95;
      return 0.9;
    }

    hasContent() {
      if (state.textOption === "yes") {
        return !!state.middleText.trim();
      }

      return state.imageUrl || state.color !== "Gloss White";
    }
    updateFinishButtonState() {
      const finishEditing = document.getElementById("finishEditing");
      if (finishEditing) {
        finishEditing.disabled = !(
          state.imageUrl ||
          state.color !== "Gloss White" ||
          state.textOption === "yes"
        );
      }
    }
    drawClipPath() {
      if (!this.canvas) return;
      const container = document.getElementById("canvasContainer");
      if (!container) return;
      if (container.clientWidth === 0 || container.clientHeight === 0) {
        // this.canvas.clear();
        // this.canvas.clipPath = null;
        // this.canvas.renderAll();
        return;
      }
      const keep = [
        this.backgroundImage,
        this.middleText,
        this.topText,
        this.bottomText,
      ].filter(Boolean);
      let old = null;
      if (this.clipPath) {
        old = {
          left: this.clipPath.left,
          top: this.clipPath.top,
          width: this.clipPath.width,
          height: this.clipPath.height,
        };
      }
      this.canvas.clear();
      this.canvas.clipPath = null;
      const { width: wIn, height: hIn } = this.getPlateSize(); // Updated to 12x6 inches
      const ratio = wIn / hIn;
      const small = window.matchMedia("(max-width: 640px)").matches;
      const fill = small ? this.mobileFillForRatio(ratio) : 0.8;
      const maxWidth = container.clientWidth * fill;
      const maxHeight = container.clientHeight * fill;
      const widthPx =
        ratio > maxWidth / maxHeight ? maxWidth : maxHeight * ratio;
      const heightPx =
        ratio > maxWidth / maxHeight ? maxWidth / ratio : maxHeight;
      const centerX = this.canvas.getWidth() / 2;
      const centerY = this.canvas.getHeight() / 2;
      const left = centerX - widthPx / 2;
      const top = centerY - heightPx / 2;
      const rx = 30; // 30px corner radius as requested

      if (!this.backgroundRect) {
        this.backgroundRect = new fabric.Rect({
          left: left,
          top: top,
          width: widthPx,
          height: heightPx,
          rx: rx,
          ry: rx,
          fill: COLOR_MAPPINGS[state.color] || "#FFFFFF",
          selectable: false,
          evented: false,
        });
        this.canvas.add(this.backgroundRect);
      } else {
        this.backgroundRect.set({
          left: left,
          top: top,
          width: widthPx,
          height: heightPx,
          rx: rx,
          ry: rx,
          fill: COLOR_MAPPINGS[state.color] || "#FFFFFF",
        });
        this.canvas.add(this.backgroundRect);
      }

      this.canvas.sendToBack(this.backgroundRect);

      const inToPx = (inches) => (widthPx / wIn) * inches; // same scale on both axes

      const holeW = inToPx(0.7);
      const holeH = inToPx(0.28);

      // distances from the edges to the hole centers
      const xInset = (wIn - 7.0) / 2; // = 2.5"
      const yInset = (hIn - 4.75) / 2; // = 0.625"

      // center positions in pixels
      const cxLeft = left + inToPx(xInset); // 2.5" from left
      const cxRight = left + inToPx(wIn - xInset); // 2.5" from right
      const cyTop = top + inToPx(yInset); // 0.625" from top
      const cyBottom = top + inToPx(hIn - yInset); // 0.625" from bottom

      const holeCenters = [
        { x: cxLeft, y: cyTop },
        { x: cxRight, y: cyTop },
        { x: cxLeft, y: cyBottom },
        { x: cxRight, y: cyBottom },
      ];

      this.holeObjects.forEach((h) => this.canvas.remove(h));
      this.holeObjects = [];

      holeCenters.forEach(({ x, y }) => {
        const hole = new fabric.Rect({
          originX: "center",
          originY: "center",
          left: x,
          top: y,
          width: holeW,
          height: holeH,
          rx: holeH / 2,
          ry: holeH / 2,
          fill: "white",
          stroke: "#000",
          strokeWidth: 1,
          strokeUniform: true,
          selectable: false,
          evented: false,
        });
        this.canvas.add(hole);
        this.holeObjects.push(hole);
      });

      this.clipPath = new fabric.Rect({
        left: left,
        top: top,
        width: widthPx,
        height: heightPx,
        rx: rx,
        ry: rx,
        selectable: false,
        evented: false,
      });
      this.canvas.clipPath = this.clipPath;

      const scale = old ? widthPx / old.width : 1;
      keep.forEach((obj) => {
        this.canvas.add(obj);
        if (old) {
          const relX = (obj.left - old.left) / old.width;
          const relY = (obj.top - old.top) / old.height;
          obj.set({
            left: left + relX * widthPx,
            top: top + relY * heightPx,
            scaleX: obj.scaleX * scale,
            scaleY: obj.scaleY * scale,
          });
        }
        obj.setCoords();
      });

      this._drawGuides();
      this._ensureHolesOnTop?.();
      this.canvas.requestRenderAll();
    }
    _drawGuides() {
      if (!this.canvas || !this.clipPath) return;

      this.guidelineObjects.forEach((o) => this.canvas.remove(o));
      this.guidelineObjects = [];

      const show = document.getElementById("toggleGuides")?.checked ?? true;
      if (!show) return;

      const clipBR = this.clipPath.getBoundingRect(true);

      // Important: stroke canvas edge پر cut نہ ہو، اس لیے guide کو اندر inset کر رہے ہیں
      const strokeWidth = 1;
      const inset = 1.5;

      const left = clipBR.left + inset;
      const top = clipBR.top + inset;
      const width = clipBR.width - inset * 2;
      const height = clipBR.height - inset * 2;

      const cx = left + width / 2;
      const cy = top + height / 2;

      const common = {
        selectable: false,
        evented: false,
        excludeFromExport: true,
        stroke: "#ec008c",
        strokeWidth,
        strokeDashArray: [6, 3],
        strokeUniform: true,
        objectCaching: false,
      };

      const rectGuide = new fabric.Rect({
        left,
        top,
        width,
        height,
        rx: Math.max(0, 30 - inset),
        ry: Math.max(0, 30 - inset),
        fill: "transparent",
        ...common,
      });

      const verticalCenter = new fabric.Line(
        [cx, top, cx, top + height],
        common,
      );

      const horizontalCenter = new fabric.Line(
        [left, cy, left + width, cy],
        common,
      );

      this.canvas.add(rectGuide, verticalCenter, horizontalCenter);
      this.guidelineObjects.push(rectGuide, verticalCenter, horizontalCenter);

      this._ensureHolesOnTop?.();
      this.canvas.requestRenderAll();
    }
    toggleGuidelines(visible) {
      if (!this.canvas) return;

      if (visible) {
        if (!this.guidelineObjects.length) {
          this._drawGuides();
        }

        this.guidelineObjects.forEach((obj) => {
          obj.visible = true;
        });
      } else {
        this.guidelineObjects.forEach((obj) => {
          obj.visible = false;
        });
      }

      this.canvas.requestRenderAll();
    }
    snapObjectSmooth(obj) {
      if (!this.canvas || !this.clipPath || !obj) return;

      const threshold = 7;
      const releaseThreshold = 16;

      const clipBR = this.clipPath.getBoundingRect(true);

      // Object controls/borders کی وجہ سے تھوڑا visual padding
      const safePad = 0.5;

      const bounds = {
        left: clipBR.left + safePad,
        top: clipBR.top + safePad,
        right: clipBR.left + clipBR.width - safePad,
        bottom: clipBR.top + clipBR.height - safePad,
        cx: clipBR.left + clipBR.width / 2,
        cy: clipBR.top + clipBR.height / 2,
      };

      obj.setCoords();

      let br = obj.getBoundingRect(true);
      let dx = 0;
      let dy = 0;

      const objCX = br.left + br.width / 2;
      const objCY = br.top + br.height / 2;

      const dist = {
        left: Math.abs(br.left - bounds.left),
        right: Math.abs(br.left + br.width - bounds.right),
        top: Math.abs(br.top - bounds.top),
        bottom: Math.abs(br.top + br.height - bounds.bottom),
        cx: Math.abs(objCX - bounds.cx),
        cy: Math.abs(objCY - bounds.cy),
      };

      // X axis: edge snap کو center snap پر priority دے رہے ہیں
      if (dist.left <= threshold) {
        dx = bounds.left - br.left;
        obj.__snapX = "left";
      } else if (dist.right <= threshold) {
        dx = bounds.right - (br.left + br.width);
        obj.__snapX = "right";
      } else if (dist.cx <= threshold) {
        dx = bounds.cx - objCX;
        obj.__snapX = "center";
      } else if (
        obj.__snapX &&
        dist[obj.__snapX === "center" ? "cx" : obj.__snapX] > releaseThreshold
      ) {
        obj.__snapX = null;
      }

      // Y axis: edge snap کو center snap پر priority دے رہے ہیں
      if (dist.top <= threshold) {
        dy = bounds.top - br.top;
        obj.__snapY = "top";
      } else if (dist.bottom <= threshold) {
        dy = bounds.bottom - (br.top + br.height);
        obj.__snapY = "bottom";
      } else if (dist.cy <= threshold) {
        dy = bounds.cy - objCY;
        obj.__snapY = "center";
      } else if (
        obj.__snapY &&
        dist[obj.__snapY === "center" ? "cy" : obj.__snapY] > releaseThreshold
      ) {
        obj.__snapY = null;
      }

      // Apply snap delta
      if (dx || dy) {
        obj.set({
          left: obj.left + dx,
          top: obj.top + dy,
        });
        obj.setCoords();
      }

      // Hard clamp: object plate سے باہر نہ نکلے
      br = obj.getBoundingRect(true);

      let clampDx = 0;
      let clampDy = 0;

      if (br.left < bounds.left) {
        clampDx = bounds.left - br.left;
      } else if (br.left + br.width > bounds.right) {
        clampDx = bounds.right - (br.left + br.width);
      }

      if (br.top < bounds.top) {
        clampDy = bounds.top - br.top;
      } else if (br.top + br.height > bounds.bottom) {
        clampDy = bounds.bottom - (br.top + br.height);
      }

      if (clampDx || clampDy) {
        obj.set({
          left: obj.left + clampDx,
          top: obj.top + clampDy,
        });
        obj.setCoords();
      }

      this.canvas.requestRenderAll();
    }
    alignObjects(direction) {
      if (!this.canvas || !this.clipPath) return;

      const activeObject = this.canvas.getActiveObject();

      const obj =
        activeObject &&
        activeObject !== this.backgroundRect &&
        !this.guidelineObjects.includes(activeObject) &&
        !this.holeObjects.includes(activeObject)
          ? activeObject
          : this.middleText || this.backgroundImage;

      if (!obj) return;

      const bounds = this.clipPath.getBoundingRect(true);
      const objW = obj.getScaledWidth();
      const objH = obj.getScaledHeight();

      let center = obj.getCenterPoint();
      let targetX = center.x;
      let targetY = center.y;

      switch (direction) {
        case "left":
          targetX = bounds.left + objW / 2;
          break;

        case "centerH":
          targetX = bounds.left + bounds.width / 2;
          break;

        case "right":
          targetX = bounds.left + bounds.width - objW / 2;
          break;

        case "top":
          targetY = bounds.top + objH / 2;
          break;

        case "centerV":
          targetY = bounds.top + bounds.height / 2;
          break;

        case "bottom":
          targetY = bounds.top + bounds.height - objH / 2;
          break;
      }

      obj.setPositionByOrigin(
        new fabric.Point(targetX, targetY),
        "center",
        "center",
      );

      obj.setCoords();
      this.canvas.setActiveObject(obj);
      this._ensureHolesOnTop?.();
      this.canvas.requestRenderAll();
    }
    updateBackgroundColor(color) {
      state.color = color;
      if (this.backgroundRect) {
        this.backgroundRect.set({ fill: COLOR_MAPPINGS[color] || "#FFFFFF" });
        this.canvas.renderAll();
      } else {
        this.drawClipPath();
      }
      this.updateFinishButtonState();
    }
    handleImageUpload(event) {
      const file = event.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = (e) => {
        state.imageUrl = e.target.result;
        state.image = file;
        fabric.Image.fromURL(
          e.target.result,
          (img) => {
            const clipBR = this.clipPath.getBoundingRect(true);
            const scale = Math.min(
              clipBR.width / img.width,
              clipBR.height / img.height,
            );
            const saved = state.imageTransform;

            img.set({
              left: saved?.left ?? clipBR.left + clipBR.width / 2,
              top: saved?.top ?? clipBR.top + clipBR.height / 2,
              originX: saved?.originX ?? "center",
              originY: saved?.originY ?? "center",
              scaleX: saved?.scaleX ?? scale,
              scaleY: saved?.scaleY ?? scale,
              angle: saved?.angle ?? 0,
              flipX: saved?.flipX ?? false,
              flipY: saved?.flipY ?? false,
              selectable: true,
              evented: true,
              hasControls: true,
              hasBorders: true,
            });
            img.setCoords();
            if (this.backgroundImage) this.canvas.remove(this.backgroundImage);
            this.canvas.add(img);
            this.backgroundImage = img;
            this.canvas.moveTo(img, this._bgTopIndex() + 1); // right above the painted background
            this._ensureHolesOnTop();
            this.canvas.renderAll();
            this.updateFinishButtonState();
          },
          { crossOrigin: "anonymous" },
        );
      };
      reader.readAsDataURL(file);
    }
    async loadFont(fontFamily) {
      if (document.fonts.check(`12px "${fontFamily}"`)) return;
      try {
        await document.fonts.load(`12px "${fontFamily}"`);
      } catch (err) {
        console.error(`Failed to load font ${fontFamily}:`, err);
      }
    }
    updateFont(font) {
      state.font = font;
      const fontFamily =
        font === "3rd Rail" ? "Third_Rail" : font.replaceAll(" ", "");
      if (this.middleText) this.middleText.set("fontFamily", fontFamily);
      if (this.topText) this.topText.set("fontFamily", fontFamily);
      if (this.bottomText) this.bottomText.set("fontFamily", fontFamily);
      this.middleText?.initDimensions();
      this.topText?.initDimensions();
      this.bottomText?.initDimensions();
      this.canvas.renderAll();
    }
    updateFontColor(color) {
      state.fontColor = color;
      const fillColor = COLOR_MAPPINGS[color] || "#000000";
      if (this.middleText) this.middleText.set("fill", fillColor);
      if (this.topText) this.topText.set("fill", fillColor);
      if (this.bottomText) this.bottomText.set("fill", fillColor);
      this.canvas.renderAll();
    }
    _fitMiddleTextToPlate(clipBR) {
      if (!this.middleText) return;

      const padX = clipBR.width * 0.06; // side padding
      const maxWidth = clipBR.width - padX * 2;
      const maxSize = Math.min(clipBR.height * 0.42, 140); // nice “big” start
      const minSize = 10;

      let size = maxSize;
      this.middleText.set({ fontSize: size });
      this.middleText.initDimensions();

      // shrink until it fits the width
      while (this.middleText.getScaledWidth() > maxWidth && size > minSize) {
        size -= 1;
        this.middleText.set({ fontSize: size });
        this.middleText.initDimensions();
      }

      // keep it centered
      this.middleText.set({
        left: clipBR.left + clipBR.width / 2,
        top: clipBR.top + clipBR.height / 2,
        originX: "center",
        originY: "center",
      });
      this.middleText.setCoords();
    }
    updateText(middleText, topText, bottomText) {
      if (!this.canvas) return;
      if (!this.clipPath) {
        this.drawClipPath();
        if (!this.clipPath) return;
      }

      // remove existing
      if (this.middleText) this.canvas.remove(this.middleText);
      if (this.topText) this.canvas.remove(this.topText);
      if (this.bottomText) this.canvas.remove(this.bottomText);

      const clipBR = this.clipPath.getBoundingRect(true);
      const fontFamily =
        state.font === "3rd Rail"
          ? "Third_Rail"
          : state.font.replaceAll(" ", "") || "Anton";
      const fillColor = COLOR_MAPPINGS[state.fontColor] || "#000000";

      if (middleText.trim() && state.textOption === "yes") {
        this.middleText = new fabric.Text(middleText, {
          fontFamily,
          fill: fillColor,
          textAlign: "center",
          lineHeight: 1,
          selectable: true,
          evented: true,
          hasControls: true,
          hasBorders: true,
        });
        this.canvas.add(this.middleText);
        this._fitMiddleTextToPlate(clipBR); // <-- auto-size to fit
      } else {
        this.middleText = null;
      }

      const baseSize = Math.min(40, clipBR.height * 0.1);
      if (topText.trim()) {
        this.topText = new fabric.Text(topText, {
          fontFamily,
          fill: fillColor,
          originX: "center",
          originY: "top",
          left: clipBR.left + clipBR.width / 2,
          top: clipBR.top + baseSize,
          fontSize: baseSize * 0.8,
          lineHeight: 1,
          selectable: false,
          evented: false,
          hasControls: false,
          hasBorders: false,
          textAlign: "center",
        });
        this.canvas.add(this.topText);
      }

      if (bottomText.trim()) {
        this.bottomText = new fabric.Text(bottomText, {
          fontFamily,
          fill: fillColor,
          originX: "center",
          originY: "bottom",
          left: clipBR.left + clipBR.width / 2,
          top: clipBR.top + clipBR.height - baseSize * 0.8,
          fontSize: baseSize * 0.8,
          lineHeight: 1,
          selectable: false,
          evented: false,
          hasControls: false,
          hasBorders: false,
          textAlign: "center",
        });
        this.canvas.add(this.bottomText);
      }

      this._ensureHolesOnTop(); // holes above text, always
      this.canvas.renderAll();
      this.updateFinishButtonState();
    }
    saveImageTransform() {
      if (!this.backgroundImage) return;

      state.imageTransform = {
        left: this.backgroundImage.left,
        top: this.backgroundImage.top,
        scaleX: this.backgroundImage.scaleX,
        scaleY: this.backgroundImage.scaleY,
        angle: this.backgroundImage.angle,
        originX: this.backgroundImage.originX,
        originY: this.backgroundImage.originY,
        flipX: this.backgroundImage.flipX,
        flipY: this.backgroundImage.flipY,
      };
    }
    validateBeforeFinish() {
      const middleVariant = document.getElementById("middle-text-variant");
      const middleInput = document.getElementById("middle-text-input");
      const middleError = document.getElementById("middle-text-error-bar");

      const needsMiddleText =
        state.textOption === "yes" && !state.middleText.trim();

      if (!needsMiddleText) {
        if (middleError) middleError.style.display = "none";
        if (middleVariant) middleVariant.classList.remove("has-error");
        return true;
      }

      if (middleError) {
        middleError.textContent =
          "Please enter Middle Text. This field is required.";
        middleError.style.display = "block";
      }

      if (middleVariant) {
        middleVariant.style.display = "";
        middleVariant.classList.add("has-error");
      }

      // Right sidebar ko Middle Text field tak scroll karo
      const sidebar = document.querySelector(".designer-tool .sidebar");

      if (sidebar && middleVariant) {
        sidebar.scrollTo({
          top: middleVariant.offsetTop - 20,
          behavior: "smooth",
        });
      } else if (middleVariant) {
        middleVariant.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }

      setTimeout(() => {
        middleInput?.focus();
      }, 350);

      return false;
    }
    finishEditing() {
      if (!this.validateBeforeFinish()) return;
      if (!this.canvas || !this.clipPath) {
        this.showError("Please create a design before finishing.");
        return;
      }
      if (!this.hasContent()) {
        this.showError(
          "Please add a background color, image, or text before finishing.",
        );
        return;
      }

      this.saveImageTransform();

      const activeObj = this.canvas.getActiveObject();
      this.canvas.discardActiveObject();

      const guideVisibility = this.guidelineObjects.map((obj) => obj.visible);
      this.guidelineObjects.forEach((obj) => {
        obj.visible = false;
      });

      this.canvas.requestRenderAll();

      const bounds = this.clipPath.getBoundingRect(true);
      const dataURL = this.canvas.toDataURL({
        left: bounds.left,
        top: bounds.top,
        width: bounds.width,
        height: bounds.height,
        format: "png",
        multiplier: 2,
        enableRetinaScaling: true,
      });
      this.guidelineObjects.forEach((obj, index) => {
        obj.visible = guideVisibility[index];
      });

      if (activeObj) {
        this.canvas.setActiveObject(activeObj);
      }

      this.canvas.requestRenderAll();
      state.editedImage = dataURLtoFile(dataURL, "license-plate.png");
      const uploadErrorEl = document.getElementById("upload-design-error");
      if (uploadErrorEl) {
        uploadErrorEl.textContent = "";
        uploadErrorEl.style.display = "none";
      }
      const artworkVariant = document.getElementById("artwork-variant");
      if (artworkVariant) artworkVariant.classList.remove("has-error");
      const previewImage = document.getElementById("preview-image");
      if (previewImage) previewImage.src = dataURL;
      const designerTool = document.getElementById("designerTool");
      const previewBox = document.getElementById("preview-box");
      const mainVariants = document.getElementById("main-variants");
      const uploadArtbox = document.getElementById("upload-artbox");
      if (designerTool) designerTool.classList.remove("active");
      enableBodyScroll();
      if (previewBox) previewBox.style.display = "block";
      if (mainVariants) mainVariants.style.display = "block";
      if (uploadArtbox) uploadArtbox.style.display = "none";
    }
    handleRemoveAll() {
      if (this.canvas) {
        this.canvas.clear();
        this.canvas.clipPath = null;
        this.canvas.dispose();
        this.canvas = null;
      }

      this.clipPath = null;
      this.backgroundRect = null;
      this.backgroundImage = null;
      this.middleText = null;
      this.topText = null;
      this.bottomText = null;
      this.guidelineObjects = [];
      this.holeObjects = [];
      this._ro?.disconnect();
      this._ro = null;

      state.image = null;
      state.imageUrl = null;
      state.imageTransform = null;
      state.editedImage = null;
      state.middleText = "";
      state.topText = "";
      state.bottomText = "";

      const designerTool = document.getElementById("designerTool");
      if (designerTool) {
        designerTool.classList.remove("active");
        enableBodyScroll();
      }

      const mainVariants = document.getElementById("main-variants");
      if (mainVariants) mainVariants.style.display = "none";

      const previewBox = document.getElementById("preview-box");
      if (previewBox) previewBox.style.display = "none";

      const uploadArtbox = document.getElementById("upload-artbox");
      if (uploadArtbox) uploadArtbox.style.display = "block";

      this.init();
      this.updateFinishButtonState();
    }
    showError(message) {
      const msgEl = document.getElementById("canvasMessage");
      if (msgEl) {
        msgEl.classList.remove("warning");
        msgEl.classList.add("error");
        msgEl.textContent = message;
        show(msgEl);
        setTimeout(() => hide(msgEl), 5000);
      }
    }
    showWarning(message) {
      const msgEl = document.getElementById("canvasMessage");
      if (msgEl) {
        msgEl.classList.remove("error");
        msgEl.classList.add("warning");
        msgEl.textContent = message;
        show(msgEl);
        setTimeout(() => hide(msgEl), 5000);
      }
    }
  }
  // =============================================
  // 16. INITIALIZE EVERYTHING
  // =============================================
  let designer = null;
  function initialize() {
    designer = new LicensePlateDesigner();
    initDropdownDefaults();
    setupTextOption();
    handleTextInputs();
    setupQuantitySelection();
    setupEmbossingSelection();
    setupApippaAddToCart();
    setupCartButtonShine();
    document.addEventListener("click", dropdownClickHandler);
    recalcPrice();
  }
  initialize();
});
